import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-game-features',
  templateUrl: './game-features.component.html',
  styleUrls: ['./game-features.component.scss']
})
export class GameFeaturesComponent {
  @Input() game: string;
  @Input() lang: string;

  titles = {
    en: {
      cs2: 'The Ultimate Counter Strike 2 Boosting Experience',
      apex: 'The Ultimate Apex Legends Boosting Experience',
      valorant: 'The Ultimate Valorant Boosting Experience',
      lol: 'The Ultimate LoL Boosting Experience',
      tft: 'The Ultimate TFT Boosting Experience',
      'wild-rift': 'The Ultimate Wild Rift Boosting Experience',
      marvel: 'The Ultimate Marvel Rivals Boosting Experience',
    },
    fr: {
      cs2: 'L\'expérience Ultime de Boosting Counter Strike 2',
      apex: 'L\'expérience Ultime de Boosting Apex Legends',
      valorant: 'L\'expérience Ultime de Boosting Valorant',
      lol: 'L\'expérience Ultime de Boosting LoL',
      tft: 'L\'expérience Ultime de Boosting TFT',
      'wild-rift': 'L\'expérience Ultime de Boosting Wild Rift',
      marvel: 'L\'expérience Ultime de Boosting Marvel Rivals',
    },
    de: {
      cs2: 'Das ultimative Counter Strike 2 Boosting Erlebnis',
      apex: 'Das ultimative Apex Legends Boosting Erlebnis',
      valorant: 'Das ultimative Valorant Boosting Erlebnis',
      lol: 'Das ultimative LoL Boosting Erlebnis',
      tft: 'Das ultimative TFT Boosting Erlebnis',
      'wild-rift': 'Das ultimative Wild Rift Boosting Erlebnis',
      marvel: 'Das ultimative Marvel Rivals Boosting Erlebnis',
    },
    pt: {
      cs2: 'A experiência suprema de boost em Counter Strike 2',
      apex: 'A experiência suprema de boost em Apex Legends',
      valorant: 'A experiência suprema de boost em Valorant',
      lol: 'A experiência suprema de boost em LoL',
      tft: 'A experiência suprema de boost em TFT',
      'wild-rift': 'A experiência suprema de boost em Wild Rift',
      marvel: 'A experiência suprema de boost em Marvel Rivals',
    },
    es: {
      cs2: 'La experiencia definitiva de Boosting en Counter Strike 2',
      apex: 'La experiencia definitiva de Boosting en Apex Legends',
      valorant: 'La experiencia definitiva de Boosting en Valorant',
      lol: 'La experiencia definitiva de Boosting en LoL',
      tft: 'La experiencia definitiva de Boosting en TFT',
      'wild-rift': 'La experiencia definitiva de Boosting en Wild Rift',
      marvel: 'La experiencia definitiva de Boosting en Marvel Rivals',
    }
  };

  miniTitles = {
    en: 'What makes GGBoost Unique',
    fr: 'Ce qui rend GGBoost Unique',
    de: 'Was macht GGBoost so einzigartig',
    pt: 'O que torna o GGBoost único',
    es: 'Lo que hace único a GGBoost',
  };

  features = {
    en: {
      cs2: [
        {
          title: '10+ Years in the Business',
          description: 'For over a decade, our focus has been on constantly pushing for excellence in game boosting.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'Our selective process attracts top-tier Global Elite players, highlighting their experience and expertise.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'With thousands of verified 5-star reviews, we take great pride leading the industry with top ratings.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'Automatic booster login through our secure app, ensuring complete anonymity of your login details.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode and Anti-Cheat system guarantees the utmost account security.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live Tracking',
          description: 'Real-time updates, rank progress, and valuable tips with our dedicated boosters, through your dashboard chat.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      apex: [
        {
          title: '10+ Years Boosting',
          description: 'With a great experience in boosting, we prioritize excellence for long-term success.',
          color: '#1c408c',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'Only Master and Apex Predator boosters are hired through a rigorous selection method.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'Proudly the top-rated website with thousands of real verified 5-star reviews on Trustpilot.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'We ensure the security of your Apex Legends Account with the most advanced measures.  ',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode, and Anti-Cheat ensure constant account security.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        }
      ],
      valorant: [
        {
          title: '10+ Years in the Business',
          description: 'We\'ve been working in the boosting sector for a long time and we\'ve always prioritized excellence.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'We only hire Immortal 3 and Radiant boosters, through a rigorous recruitment process.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'With thousands of verified 5 stars reviews, we are proud to be the top rated website in the business.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'To guarantee your account`s safety, we ensure that boosters never have access to any of your login details.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode and Anti-Cheat system guarantees that your account is secure at all times.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live Tracking',
          description: 'Real Time Access to the most recent order updates, including match history and rank progression.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      lol: [
        {
          title: '10+ Years in the Business',
          description: 'After numerous years in the boosting sector, we remain committed to the highest quality standards.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'We exclusively hire Master, Grandmaster, and Challenger players in a rigorous recruitment.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'We are proud to have thousands of verified 5 star reviews, making us the highest rated website in the sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'To preserve the security of your account, we never share your login information with boosters.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode, and Anti-Cheat system guarantees your account\'s security at all times.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live Tracking',
          description: 'Access in real time the most recent order updates, including match history and rank progression.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      tft: [
        {
          title: '10+ Years in the Business',
          description: 'After many years in the boosting sector, we continue to commit to the highest quality standards.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'We only hire Master, Grandmaster and Challenger boosters, through a rigorous recruitment process.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'With thousands of verifiable 5 star reviews, we are proud to be the highest rated website in the sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'To safeguard the security of your account, we never give boosters access to your login information.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode, and Anti-Cheat system ensures the security of your account at all times.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live Tracking',
          description: 'Access to the most recent order updates, including match history and rank progression, in real time.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      'wild-rift': [
        {
          title: '10+ Years in the Business',
          description: 'After many years in the boosting sector, we remain committed to the highest quality standards.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'We make a careful selection of boosters ranked Master, Grandmaster and Challenger.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'We are happy to have thousands of verified 5 star reviews, making us the highest rated website in the sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'To protect the security of your account, we never provide boosters with access to your login details.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode, and Anti-Cheat system ensures that your account is always protected.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live Tracking',
          description: 'Real-time access to the latest order updates, such as match history and rank progression.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      marvel: [
        {
          title: '10+ Years in the Business',
          description: 'For over a decade, our focus has been on constantly pushing for excellence in game boosting.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'The Best Boosters',
          description: 'Our selective process attracts top-tier Eternity+ players, highlighting their experience and expertise.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Certified Quality',
          description: 'With thousands of verified 5-star reviews, we take great pride leading the industry with top ratings.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login Encryption',
          description: 'Automatic booster login through our secure app, ensuring complete anonymity of your login details.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Superior Protection',
          description: 'Our Advanced VPN, Offline Mode and Anti-Cheat system guarantees the utmost account security.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live Tracking',
          description: 'Real-time updates, rank progress, and valuable tips with our dedicated boosters, through your dashboard chat.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
    },
    fr: {
      cs2: [
        {
          title: '10+ ans dans le business',
          description: 'Depuis plus d\'une décennie, notre objectif a été de constamment rechercher l\'excellence dans le domaine du boosting de jeu.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Notre processus sélectif permet d\'attirer des joueurs de l\'élite mondiale, en mettant en valeur leur expérience et leur expertise.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Avec des milliers d\'avis 5 étoiles vérifiés, nous sommes très fiers d\'être leader du secteur avec les meilleures évaluations.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Connexion automatique du booster via notre application sécurisée, garantissant l\'anonymat total de vos identifiants de connexion.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, notre mode hors ligne et notre système anti-cheat garantissent une sécurité maximale des comptes.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Suivi en direct',
          description: 'Mises à jour en temps réel, progression du rang et conseils précieux avec nos boosters dévoués, via le chat de votre tableau de bord.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      apex: [
        {
          title: '10+ ans de Boosting',
          description: 'Avec une grande expérience dans le domaine du boosting, nous priorisons l\'excellence pour un succès à long terme.',
          color: '#1c408c',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Seuls les boosters Maître et Apex Prédateur sont engagés par le biais d\'une sélection rigoureuse.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Nous sommes fiers d\'être le site web le mieux noté avec des milliers d\'avis 5 étoiles vérifiés sur Trustpilot.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Nous assurons la sécurité de votre compte Apex Legends grâce aux mesures les plus avancées.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, le mode hors ligne et l\'Anti-Cheat garantissent une sécurité constante du compte.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        }
      ],
      valorant: [
        {
          title: '10+ ans dans le Business',
          description: 'Nous travaillons depuis longtemps dans le secteur du boosting et nous avons toujours privilégié l\'excellence.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Nous n\'engageons que des boosters Immortel 3 et Radiant, via un processus de recrutement rigoureux.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Avec des milliers d\'avis 5 étoiles vérifiés, nous sommes fiers d\'être le site web le mieux noté du secteur.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Pour garantir la sécurité de votre compte, nous veillons à ce que les boosters n\'aient jamais accès à vos identifiants de connexion.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, notre mode hors ligne et notre système anti-cheat garantissent la sécurité de votre compte à tout moment.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Suivi en direct',
          description: 'Accès en temps réel aux mises à jour les plus récentes de la commande, y compris l\'historique des matchs et la progression du rang.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      lol: [
        {
          title: '10+ ans dans le Business',
          description: 'Après de nombreuses années dans le secteur du boosting, nous restons attachés aux normes de qualité les plus élevées.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Nous recrutons exclusivement des joueurs de niveau Maître, Grand Maître et Challenger à l\'issue d\'un processus de recrutement rigoureux.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Nous sommes fiers d\'avoir des milliers d\'avis 5 étoiles vérifiés, ce qui fait de nous le site web le mieux noté du secteur.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Pour préserver la sécurité de votre compte, nous ne partageons jamais vos identifiants avec les boosters.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, notre mode hors ligne et notre système anti-cheat garantissent la sécurité de votre compte à tout moment.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Suivi en direct',
          description: 'Accédez en temps réel aux dernières mises à jour de la commande, y compris l\'historique des matchs et la progression du rang.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      tft: [
        {
          title: '10+ ans dans le Business',
          description: 'Après de nombreuses années dans le secteur du boosting, nous continuons à nous engager à appliquer les normes de qualité les plus élevées.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Nous n\'engageons que des boosters Master, Grandmaster et Challenger, à travers un processus de recrutement rigoureux.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Avec des milliers d\'avis 5 étoiles vérifiables, nous sommes fiers d\'être le site web le mieux noté du secteur.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Pour garantir la sécurité de votre compte, nous ne donnons jamais aux boosters l\'accès à vos identifiants de connexion.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, notre mode hors ligne et notre système anti-cheat garantissent la sécurité de votre compte à tout moment.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Suivi en direct',
          description: 'Accès aux dernières mises à jour de la commande, y compris l\'historique des matchs et la progression du rang, en temps réel.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      'wild-rift': [
        {
          title: '10+ ans dans le Business',
          description: 'Après de nombreuses années dans le secteur du boosting, nous restons attachés aux normes de qualité les plus élevées.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Nous sélectionnons soigneusement des boosters classés Maître, Grand Maître et Challenger.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Nous sommes heureux de disposer de milliers d\'avis 5 étoiles vérifiés, ce qui fait de nous le site web le mieux noté du secteur.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Pour protéger la sécurité de votre compte, nous ne donnons jamais aux boosters l\'accès à vos identifiants de connexion.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, notre mode hors ligne et notre système anti-cheat garantissent que votre compte est toujours protégé.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Suivi en direct',
          description: 'Accès en temps réel aux dernières mises à jour de la commande, telles que l\'historique des matchs et la progression du rang.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      marvel: [
        {
          title: '10+ ans dans le business',
          description: 'Depuis près d\'une décennie, nous nous efforçons constamment d\'atteindre l\'excellence dans le domaine du boosting de jeu.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Les Meilleurs Boosters',
          description: 'Notre processus de sélection attire les meilleurs joueurs Eternity+, mettant en avant leur expérience et expertise.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualité Certifiée',
          description: 'Avec des milliers d\'avis 5 étoiles vérifiés, nous sommes très fiers d\'être leader du secteur avec les meilleures évaluations.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Chiffrement de la Connexion',
          description: 'Connexion automatique du booster via notre application sécurisée, garantissant l\'anonymat total de vos identifiants de connexion.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protection Supérieure',
          description: 'Notre VPN avancé, notre mode hors ligne et notre système anti-cheat garantissent une sécurité maximale des comptes.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Suivi en direct',
          description: 'Mises à jour en temps réel, progression du rang et conseils précieux avec nos boosters dévoués, via le chat de votre tableau de bord.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
    },
    de: {
      cs2: [
        {
          title: '10+ Jahre in der Branche',
          description: 'Seit über einem Jahrzehnt liegt unser Fokus darauf, ständig nach Exzellenz im Bereich des Game-Boostings zu streben.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Booster',
          description: 'Unser Auswahlverfahren zieht aufgrund ihrer Erfahrung und ihres Fachwissens die besten Akteure der globalen Elite an.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Mit Tausenden von verifizierten 5-Sterne-Bewertungen sind wir stolz darauf, dass wir in der Branche führend sind, wenn es darum geht, die besten Bewertungen zu erhalten.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Automatische Anmeldung über unsere sichere App, die garantiert, dass deine Anmeldedaten anonymisiert bleiben.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Höchste Sicherheit für dein Konto garantieren unsere fortschrittlichen VPN-, Offline-Modus- und Anti-Cheat-Systeme.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live-Tracking',
          description: 'Über den Chat auf deinem Dashboard erhältst du Echtzeit-Updates, Rangfortschritte und wertvolle Tipps von unseren engagierten Boostern.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      apex: [
        {
          title: '10+ Jahre Boosting',
          description: 'Wir setzen auf Exzellenz für langfristigen Erfolg durch unsere langjährige Erfahrung im Bereich Boosting.',
          color: '#1c408c',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Boosters',
          description: 'Nur Master und Apex Predator Booster werden nach einem strengen Auswahlverfahren eingestellt.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Wir sind stolz darauf, die am besten bewertete Website mit Tausenden von echten, verifizierten 5-Sterne-Bewertungen auf Trustpilot zu sein.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Wir gewährleisten die Sicherheit deines Apex Legends-Kontos mit den modernsten Maßnahmen.  ',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Unser fortschrittliches VPN, der Offline-Modus und Anti-Cheat sorgen für ständige Kontosicherheit.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        }
      ],
      valorant: [
        {
          title: '10+ Jahre in der Branche',
          description: 'Wir sind schon seit langer Zeit in der Boosting-Branche tätig und haben schon immer großen Wert auf Exzellenz gelegt.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Booster',
          description: 'Wir stellen nur Immortal 3 und Radiant Booster ein, die ein strenges Einstellungsverfahren durchlaufen haben.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Mit Tausenden von verifizierten 5-Sterne-Bewertungen sind wir stolz darauf, die am besten bewertete Website der Branche zu sein.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Wir stellen sicher, dass Booster niemals Zugang zu deinen Anmeldedaten haben, um die Sicherheit deines Kontos zu gewährleisten.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Unser fortschrittliches VPN-, Offline-Modus- und Anti-Cheat-System garantiert, dass dein Konto jederzeit sicher ist.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live-Tracking',
          description: 'Echtzeit-Zugriff auf die neuesten Auftragsaktualisierungen, einschließlich Spielverlauf und Ranglistenentwicklung.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      lol: [
        {
          title: '10+ Jahre in der Branche',
          description: 'Den höchsten Qualitätsstandards fühlen wir uns auch nach vielen Jahren in der Boosting-Branche verpflichtet.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Booster',
          description: 'Wir stellen ausschließlich Master-, Grandmaster- und Challenger-Spieler in einem strengen Auswahlverfahren ein.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Wir sind stolz darauf, dass wir Tausende von verifizierten 5-Sterne-Bewertungen haben. Damit sind wir die am besten bewertete Website in diesem Bereich.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Um sicherzustellen, dass dein Account sicher und geschützt bleibt, geben wir deine Login-Daten niemals an Booster weiter.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Die Sicherheit deines Kontos wird durch unsere fortschrittlichen VPN-, Offline-Modus- und Anti-Cheat-Systeme jederzeit gewährleistet.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live-Tracking',
          description: 'Du hast Zugriff auf die aktuellsten Missionsupdates in Echtzeit. Dazu gehören auch die Spielhistorie und die Ranglistenentwicklung.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      tft: [
        {
          title: '10+ Jahre in der Branche',
          description: 'Nach vielen Jahren in der Boosting-Branche verpflichten wir uns weiterhin zu höchsten Qualitätsstandards.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Booster',
          description: 'Wir stellen nur Master-, Grandmaster- und Challenger-Booster ein, die nach einem strengen Auswahlverfahren ausgewählt werden.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Wir sind stolz darauf, die am besten bewertete Website in diesem Bereich zu sein. Tausende nachprüfbare 5-Sterne-Bewertungen belegen dies.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Um die Sicherheit deines Kontos zu gewährleisten, geben wir Booster niemals Zugang zu deinen Anmeldedaten.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Mit unserem fortschrittlichen VPN, dem Offline-Modus und dem Anti-Cheat-System ist die Sicherheit deines Kontos jederzeit gewährleistet.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live-Tracking',
          description: 'Zugriff auf die neuesten Auftrags-Updates, einschließlich Spielverlauf und Rangentwicklung, in Echtzeit.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      'wild-rift': [
        {
          title: '10+ Jahre in der Branche',
          description: 'Nach vielen Jahren in der Boosting-Branche sind wir weiterhin den höchsten Qualitätsstandards verpflichtet.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Booster',
          description: 'Wir treffen eine sorgfältige Auswahl der Booster mit den Rängen Master, Grandmaster und Challenger.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Wir freuen uns, dass wir Tausende von verifizierten 5-Sterne-Bewertungen haben. Damit sind wir die am besten bewertete Website der Branche.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Wir geben Boostern niemals Zugang zu deinen Anmeldedaten, um die Sicherheit deines Kontos zu schützen.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Unser fortschrittliches VPN-, Offline-Modus- und Anti-Cheat-System sorgt dafür, dass dein Konto immer geschützt ist.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live-Tracking',
          description: 'Echtzeit-Zugriff auf die neuesten Auftrags-Updates, wie z.B. den Spielverlauf und den Rangaufstieg.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      marvel: [
        {
          title: '10+ Jahre in der Branche',
          description: 'Seit mehr als einem Jahrzehnt konzentrieren wir uns darauf, immer wieder neue Spitzenleistungen im Bereich der Spielverbesserung zu erzielen.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Die besten Booster',
          description: 'Unser Auswahlverfahren zieht Top-Spieler aus Eternity+ an und hebt ihre Erfahrung und Expertise hervor.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Zertifizierte Qualität',
          description: 'Mit Tausenden von verifizierten 5-Sterne-Bewertungen sind wir stolz darauf, dass wir in der Branche führend sind, wenn es darum geht, die besten Bewertungen zu erhalten.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Login-Verschlüsselung',
          description: 'Automatische Anmeldung über unsere sichere App, die garantiert, dass deine Anmeldedaten anonymisiert bleiben.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Überlegener Schutz',
          description: 'Höchste Sicherheit für dein Konto garantieren unsere fortschrittlichen VPN-, Offline-Modus- und Anti-Cheat-Systeme.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Live-Tracking',
          description: 'Über den Chat auf deinem Dashboard erhältst du Echtzeit-Updates, Rangfortschritte und wertvolle Tipps von unseren engagierten Boostern.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
    },
    pt: {
      cs2: [
        {
          "title": "Mais de 8 Anos no Negócio",
          "description": "Há mais de uma década, o nosso foco tem sido constantemente procurar a excelência no boost de jogos.",
          "color": "#345fdb",
          "icon": "/valorant/icons/console.png"
        },
        {
          "title": "Os Melhores Boosters",
          "description": "Nosso processo seletivo atrai jogadores de elite Global Elite de alto nível, destacando sua experiência e expertise.",
          "color": "#ffbb34",
          "icon": "/valorant/icons/group.png"
        },
        {
          "title": "Qualidade Certificada",
          "description": "Com milhares de avaliações verificadas com 5 estrelas, nos orgulhamos de liderar o setor com as melhores avaliações.",
          "color": "#ff5353",
          "icon": "/valorant/icons/medal.png"
        },
        {
          "title": "Criptografia de Login",
          "description": "Login automático do booster através de nosso aplicativo seguro, garantindo total anonimato de seus detalhes de login.",
          "color": "#2ec565",
          "icon": "/valorant/icons/padlock.png"
        },
        {
          "title": "Proteção Superior",
          "description": "Nosso VPN avançado, Modo Offline e sistema Anti-Cheat garantem a máxima segurança da conta.",
          "color": "#9853ff",
          "icon": "/valorant/icons/security.png"
        },
        {
          "title": "Actualizações Ao Vivo",
          "description": "Atualizações em tempo real, progresso de classificação e dicas valiosas com nossos boosters dedicados, através do chat do seu painel.",
          "color": "#ff9253",
          "icon": "/valorant/icons/aim.png"
        }
      ],
      apex: [
        {
          "title": "Mais de 8 Anos de Boosting",
          "description": "Com grande experiência em boosting, priorizamos a excelência para o sucesso a longo prazo.",
          "color": "#1c408c",
          "icon": "/valorant/icons/console.png"
        },
        {
          "title": "Os Melhores Boosters",
          "description": "Apenas boosters Master e Apex Predator são contratados através de um rigoroso método de seleção.",
          "color": "#ffbb34",
          "icon": "/valorant/icons/group.png"
        },
        {
          "title": "Qualidade Certificada",
          "description": "Orgulhosamente o site com a melhor classificação com milhares de avaliações reais verificadas com 5 estrelas no Trustpilot.",
          "color": "#ff5353",
          "icon": "/valorant/icons/medal.png"
        },
        {
          "title": "Criptografia de Login",
          "description": "Garantimos a segurança da tua conta Apex Legends com as medidas mais sofisticadas.",
          "color": "#2ec565",
          "icon": "/valorant/icons/padlock.png"
        },
        {
          "title": "Proteção Superior",
          "description": "O VPN avançado, Modo Offline e Anti-Cheat garantem a segurança constante da conta",
          "color": "#9853ff",
          "icon": "/valorant/icons/security.png"
        }
      ],
      valorant: [
        {
          "title": "Mais de 8 Anos no Negócio",
          "description": "Trabalhamos no setor de boosting há muito tempo e sempre priorizamos a excelência.",
          "color": "#345fdb",
          "icon": "/valorant/icons/console.png"
        },
        {
          "title": "Os Melhores Boosters",
          "description": "Contratamos apenas boosters Immortal 3 e Radiant, através de um rigoroso processo de recrutamento.",
          "color": "#ffbb34",
          "icon": "/valorant/icons/group.png"
        },
        {
          "title": "Qualidade Certificada",
          "description": "Com milhares de avaliações verificadas com 5 estrelas, nos orgulhamos de ser o site com a melhor classificação do setor.",
          "color": "#ff5353",
          "icon": "/valorant/icons/medal.png"
        },
        {
          "title": "Criptografia de Login",
          "description": "Para garantir a segurança de sua conta, garantimos que os boosters nunca tenham acesso às suas informações de login.",
          "color": "#2ec565",
          "icon": "/valorant/icons/padlock.png"
        },
        {
          "title": "Proteção Superior",
          "description": "Nosso VPN avançado, Modo Offline e sistema Anti-Cheat garantem que sua conta esteja segura o tempo todo.",
          "color": "#9853ff",
          "icon": "/valorant/icons/security.png"
        },
        {
          "title": "Actualizações Ao Vivo",
          "description": "Acesso em tempo real às atualizações mais recentes do pedido, incluindo histórico de partidas e progresso de classificação.",
          "color": "#ff9253",
          "icon": "/valorant/icons/aim.png"
        }
      ],
      lol: [
        {
          "title": "Mais de 8 Anos no Negócio",
          "description": "Após vários anos no setor de boosting, permanecemos comprometidos com os mais altos padrões de qualidade.",
          "color": "#345fdb",
          "icon": "/valorant/icons/console.png"
        },
        {
          "title": "Os Melhores Boosters",
          "description": "Contratamos exclusivamente jogadores Mestre, Grande Mestre e Desafiante em um rigoroso processo de recrutamento.",
          "color": "#ffbb34",
          "icon": "/valorant/icons/group.png"
        },
        {
          "title": "Qualidade Certificada",
          "description": "Temos orgulho de ter milhares de avaliações verificadas com 5 estrelas, tornando-nos o site com a melhor classificação no setor.",
          "color": "#ff5353",
          "icon": "/valorant/icons/medal.png"
        },
        {
          "title": "Criptografia de Login",
          "description": "Para preservar a segurança de sua conta, nunca compartilhamos suas informações de login com os boosters.",
          "color": "#2ec565",
          "icon": "/valorant/icons/padlock.png"
        },
        {
          "title": "Proteção Superior",
          "description": "Nosso VPN avançado, Modo Offline e sistema Anti-Cheat garantem a segurança de sua conta o tempo todo.",
          "color": "#9853ff",
          "icon": "/valorant/icons/security.png"
        },
        {
          "title": "Actualizações Ao Vivo",
          "description": "Acesso em tempo real às atualizações mais recentes do pedido, incluindo histórico de partidas e progresso de classificação.",
          "color": "#ff9253",
          "icon": "/valorant/icons/aim.png"
        }
      ],
      tft: [
        {
          "title": "Mais de 8 Anos no Negócio",
          "description": "Depois de muitos anos no setor de boosting, continuamos comprometidos com os mais altos padrões de qualidade.",
          "color": "#345fdb",
          "icon": "/valorant/icons/console.png"
        },
        {
          "title": "Os Melhores Boosters",
          "description": "Contratamos apenas boosters Mestre, Grande Mestre e Desafiante, através de um rigoroso processo de recrutamento.",
          "color": "#ffbb34",
          "icon": "/valorant/icons/group.png"
        },
        {
          "title": "Qualidade Certificada",
          "description": "Com milhares de avaliações verificáveis com 5 estrelas, nos orgulhamos de ser o site com a melhor classificação no setor.",
          "color": "#ff5353",
          "icon": "/valorant/icons/medal.png"
        },
        {
          "title": "Criptografia de Login",
          "description": "Para salvaguardar a segurança de sua conta, nunca concedemos aos boosters acesso às suas informações de login.",
          "color": "#2ec565",
          "icon": "/valorant/icons/padlock.png"
        },
        {
          "title": "Proteção Superior",
          "description": "Nosso VPN avançado, Modo Offline e sistema Anti-Cheat garantem a segurança de sua conta o tempo todo.",
          "color": "#9853ff",
          "icon": "/valorant/icons/security.png"
        },
        {
          "title": "Actualizações Ao Vivo",
          "description": "Acesso em tempo real às atualizações mais recentes do pedido, incluindo histórico de partidas e progresso de classificação.",
          "color": "#ff9253",
          "icon": "/valorant/icons/aim.png"
        }
      ],
      'wild-rift': [
        {
          title: 'Mais de 8 Anos no Negócio',
          description: 'Após muitos anos no setor de boosting, continuamos comprometidos com os mais altos padrões de qualidade.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Os Melhores Boosters',
          description: 'Fazemos uma seleção cuidadosa de boosters classificados como Mestre, Grão-Mestre e Desafiante.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Qualidade Certificada',
          description: 'Temos orgulho de ter milhares de avaliações verificadas de 5 estrelas, tornando-nos o site mais bem avaliado no setor.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Criptografia de Login',
          description: 'Para proteger a segurança da sua conta, nunca fornecemos aos boosters acesso aos seus dados de login.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Proteção Superior',
          description: 'Nosso VPN avançado, modo offline e sistema anti-cheat garantem que sua conta esteja sempre protegida.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Acompanhamento ao Vivo',
          description: 'Acesso em tempo real às últimas atualizações de pedidos, como histórico de partidas e progresso de rank.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      marvel: [
        {
          "title": "Mais de 8 Anos no Negócio",
          "description": "Há quase uma década, o nosso foco tem sido constantemente procurar a excelência no boost de jogos.",
          "color": "#345fdb",
          "icon": "/valorant/icons/console.png"
        },
        {
          "title": "Os Melhores Boosters",
          "description": "O nosso processo seletivo atrai jogadores de elite Eternity+, destacando a sua experiência e perícia.",
          "color": "#ffbb34",
          "icon": "/valorant/icons/group.png"
        },
        {
          "title": "Qualidade Certificada",
          "description": "Com milhares de avaliações verificadas com 5 estrelas, nos orgulhamos de liderar o setor com as melhores avaliações.",
          "color": "#ff5353",
          "icon": "/valorant/icons/medal.png"
        },
        {
          "title": "Criptografia de Login",
          "description": "Login automático do booster através de nosso aplicativo seguro, garantindo total anonimato de seus detalhes de login.",
          "color": "#2ec565",
          "icon": "/valorant/icons/padlock.png"
        },
        {
          "title": "Proteção Superior",
          "description": "Nosso VPN avançado, Modo Offline e sistema Anti-Cheat garantem a máxima segurança da conta.",
          "color": "#9853ff",
          "icon": "/valorant/icons/security.png"
        },
        {
          "title": "Actualizações Ao Vivo",
          "description": "Atualizações em tempo real, progresso de classificação e dicas valiosas com nossos boosters dedicados, através do chat do seu painel.",
          "color": "#ff9253",
          "icon": "/valorant/icons/aim.png"
        }
      ],
    },
    es: {
      cs2: [
        {
          title: 'Más de 8 años en el sector',
          description: 'Durante más de una década, nos hemos centrado en la búsqueda constante de la excelencia en el Boost de videojuegos.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Nuestro proceso selectivo atrae a jugadores de élite mundial de primer nivel, lo que pone de relieve su experiencia y conocimientos.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Con miles de opiniones verificadas de 5 estrellas, nos enorgullecemos de liderar el sector con las mejores valoraciones.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Inicio de sesión automático para boosters a través de nuestra aplicación segura, que garantiza el anonimato total de tus datos de inicio de sesión.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan la máxima seguridad de la cuenta.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Seguimiento en directo',
          description: 'Actualizaciones en tiempo real, progreso en el rango y valiosos consejos con nuestros boosters dedicados, a través del chat de tu dashboard.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      apex: [
        {
          title: '10+ Años Boosting',
          description: 'Con una gran experiencia en boosting, priorizamos la excelencia para el éxito a largo plazo.',
          color: '#1c408c',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Sólo los boosters Master y Apex Predator son contratados a través de un riguroso método de selección.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Orgullosamente el sitio web mejor valorado con miles de opiniones reales verificadas de 5 estrellas en Trustpilot.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Garantizamos la seguridad de tu cuenta de Apex Legends con las medidas más avanzadas.  ',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan la máxima seguridad de la cuenta.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        }
      ],
      valorant: [
        {
          title: 'Más de 8 años en el sector',
          description: 'Llevamos mucho tiempo trabajando en el sector del boosting y siempre hemos dado prioridad a la excelencia.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Sólo contratamos boosters de Inmortal 3 y Radiant, a través de un riguroso proceso de selección.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Con miles de opiniones verificadas de 5 estrellas, estamos orgullosos de ser el sitio web mejor valorado del sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Para garantizar la seguridad de tu cuenta, nos aseguramos de que los boosters nunca tengan acceso a tus datos de acceso.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan la máxima seguridad de la cuenta.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Seguimiento en directo',
          description: 'Acceso en tiempo real a las actualizaciones más recientes de las órdenes, incluido el historial de partidos y la progresión en la clasificación.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      lol: [
        {
          title: 'Más de 8 años en el sector',
          description: 'Más de 8 años en el sector',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Contratamos exclusivamente a jugadores Master, Grandmaster y Challenger en un riguroso proceso de selección.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Estamos orgullosos de contar con miles de opiniones verificadas de 5 estrellas, lo que nos convierte en el sitio web mejor valorado del sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Para preservar la seguridad de tu cuenta, nunca compartimos tus datos de acceso con boosters.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan la máxima seguridad de la cuenta.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Seguimiento en directo',
          description: 'Accede en tiempo real a las actualizaciones más recientes de las órdenes, incluido el historial de partidos y la progresión en la clasificación.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      tft: [
        {
          title: 'Más de 8 años en el sector',
          description: 'Tras muchos años en el sector del boosting, seguimos comprometidos con los más altos estándares de calidad.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Sólo contratamos boosters Master, Grandmaster y Challenger, a través de un riguroso proceso de selección.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Con miles de opiniones verificables de 5 estrellas, estamos orgullosos de ser el sitio web mejor valorado del sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Para salvaguardar la seguridad de tu cuenta, nunca damos acceso a tus datos de acceso a los boosters.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan la seguridad de tu cuenta en todo momento.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Seguimiento en directo',
          description: 'Accede a las actualizaciones más recientes de las órdenes, incluido el historial de partidos y la progresión en la clasificación, en tiempo real.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      'wild-rift': [
        {
          title: 'Más de 8 años en el sector',
          description: 'Tras muchos años en el sector del boosting, seguimos comprometidos con los más altos estándares de calidad.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Hacemos una cuidadosa selección de boosters clasificados Master, Grandmaster y Challenger.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Nos complace contar con miles de opiniones verificadas de 5 estrellas, lo que nos convierte en el sitio web mejor valorado del sector.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Para proteger la seguridad de tu cuenta, nunca proporcionamos a los boosters acceso a tus datos de acceso.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan que tu cuenta esté siempre protegida.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Seguimiento en directo',
          description: 'Accede en tiempo real a las últimas actualizaciones de las órdenes, como el historial de partidos y la progresión en la clasificación.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
      marvel: [
        {
          title: 'Más de 8 años en el sector',
          description: 'Durante casi una década, nos hemos centrado en la búsqueda constante de la excelencia en el Boost de videojuegos.',
          color: '#345fdb',
          icon: '/valorant/icons/console.png'
        },
        {
          title: 'Los mejores boosters',
          description: 'Nuestro proceso selectivo atrae a los mejores jugadores de Eternity+, resaltando su experiencia y habilidad.',
          color: '#ffbb34',
          icon: '/valorant/icons/group.png'
        },
        {
          title: 'Calidad certificada',
          description: 'Con miles de opiniones verificadas de 5 estrellas, nos enorgullecemos de liderar el sector con las mejores valoraciones.',
          color: '#ff5353',
          icon: '/valorant/icons/medal.png'
        },
        {
          title: 'Cifrado de inicio de sesión',
          description: 'Inicio de sesión automático para boosters a través de nuestra aplicación segura, que garantiza el anonimato total de tus datos de inicio de sesión.',
          color: '#2ec565',
          icon: '/valorant/icons/padlock.png'
        },
        {
          title: 'Protección superior',
          description: 'Nuestra VPN avanzada, el modo Offline y el sistema Anti-Cheat garantizan la máxima seguridad de la cuenta.',
          color: '#9853ff',
          icon: '/valorant/icons/security.png'
        },
        {
          title: 'Seguimiento en directo',
          description: 'Actualizaciones en tiempo real, progreso en el rango y valiosos consejos con nuestros boosters dedicados, a través del chat de tu dashboard.',
          color: '#ff9253',
          icon: '/valorant/icons/aim.png'
        }
      ],
    }
  }
}